exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3JhTC512ydLqFE5jhyxH-e{width:100%;min-height:80px;height:80px}._2od-kywpbHIvMAGV0hgQyU{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}html[dir=ltr] ._1Mbyv9kwgSc9pA3P71RZIL{margin-right:8px}html[dir=rtl] ._1Mbyv9kwgSc9pA3P71RZIL{margin-left:8px}", ""]);

// exports
exports.locals = {
	"container": "_3JhTC512ydLqFE5jhyxH-e",
	"buttonContainer": "_2od-kywpbHIvMAGV0hgQyU",
	"button": "_1Mbyv9kwgSc9pA3P71RZIL"
};